import { useAuth } from "../../context/AuthContext";
import { AlertTriangle } from "lucide-react";
import { Button } from "../ui/button";

export const SessionTimeoutWarning = () => {
  const { showTimeoutWarning, timeoutCountdown, extendSession, logout } = useAuth();

  if (!showTimeoutWarning) return null;

  const minutes = Math.floor(timeoutCountdown / 60);
  const seconds = timeoutCountdown % 60;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm" data-testid="session-timeout-warning">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4 animate-in fade-in zoom-in-95 duration-200">
        <div className="flex flex-col items-center text-center">
          <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mb-4">
            <AlertTriangle className="w-7 h-7 text-amber-600" />
          </div>

          <h2 className="text-xl font-bold text-slate-900 mb-2" style={{ fontFamily: "Outfit, sans-serif" }}>
            Session Expiring Soon
          </h2>

          <p className="text-slate-600 text-sm mb-1">
            Your session will expire due to inactivity.
          </p>

          <div className="text-3xl font-mono font-bold text-red-600 my-4" data-testid="timeout-countdown">
            {minutes}:{seconds.toString().padStart(2, "0")}
          </div>

          <p className="text-slate-500 text-xs mb-6">
            Click below to stay logged in, or you will be automatically signed out.
          </p>

          <div className="flex gap-3 w-full">
            <Button
              variant="outline"
              onClick={logout}
              className="flex-1 h-11 rounded-xl text-sm border-slate-200"
              data-testid="session-logout-btn"
            >
              Sign Out
            </Button>
            <Button
              onClick={extendSession}
              className="flex-1 h-11 rounded-xl text-sm bg-[#00346f] hover:bg-[#004a9e] text-white"
              data-testid="session-extend-btn"
            >
              Stay Logged In
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
